import { AxiosError, AxiosResponse } from 'axios';
import { useQueryClient, useMutation, UseMutationResult } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

function useWodupCreate(): UseMutationResult<AxiosResponse<{}>, AxiosError<ErrorMessage>, string> {
  const queryClient = useQueryClient();

  const createAthlete = (athleteId: string): Promise<AxiosResponse<{}>> => {
    return client.post(`athletes/${athleteId}/subscribe-to-wodup/`);
  };

  return useMutation(createAthlete, {
    onSuccess: () => {
      queryClient.invalidateQueries('athletes');
    },
  });
}

export default useWodupCreate;
